<template>
    <BModal :model-value="modal" scrollable centered title="Schedule" @update:modelValue="updateModal"> 
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Schedule</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="updateModal(false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>
        <BForm>
            <div class="form-group">
                <BFormSelect v-model="selectHousekeeping" :options="housekeepers" class="form-select">
                    <template #first>
                        <BFormSelectOption :value="null" disabled>Select Housekeeping</BFormSelectOption>
                    </template>
                </BFormSelect>
            </div>
            <BRow v-for="room, index in rooms" :key="index" class="mr-lg-3 mb-3 mb-lg-0">
                <BCol md="10">
                    <div class="form-group">
                        <BFormSelect v-model="selectNoRoom" :options="room.no_rooms" class="form-select">
                            <template #first>
                                <BFormSelectOption :value="null" disabled>Select no Room</BFormSelectOption>
                            </template>
                        </BFormSelect>
                    </div>
                </BCol>
                <BCol md="2">
                    <div class="d-flex ">
                        <BButton variant="light" @click="addRoom(index)"><i class="fas fa-plus"></i></BButton>
                        <BButton variant="light" class="ml-2" @click="deleteRoom(index)"><i class="fas fa-minus"></i></BButton>
                        
                    </div>
                </BCol>
            </BRow>
        </BForm>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" @click="submitReservation" class="mr-2">Save</BButton>
                <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
  </template>
  
  <script>
  import { ref } from "vue";
  import { 
    BRow, 
    BCol, 
    BModal, 
    BButton,
    BFormSelect,
    BFormSelectOption,
    // BFormTextArea, 
    // BFormInput 
} from "bootstrap-vue-next";
  
  export default {
      name: 'ScheduleForm',
      components: {
          BRow,
          BCol,
          BModal,
          BButton,
          BFormSelect,
          BFormSelectOption,
        //   BFormInput,
        //   BFormTextArea,
        
      },
      props: {
          modal: Boolean,
      },
      setup(props, {emit}){
          console.log(props)

          const selectHousekeeping = ref(null)
          const housekeepers = ref([
              'Budi', 'Andi', 'Siti', 'Mamat', 'Rina'
            ])
          const selectNoRoom = ref(null)
          const type_rooms = ref([
            'Deluxe', 'Super Deluxe', 'Honeymoon', 'Family', 'Studio'
          ])

          const rooms = ref([
            {
                no_rooms: [
                    {
                        text: 'A1',
                        value: 'a1',
                    }
                ]
            }
          ]
          )
          const addRoom = (index) => {
            const item = rooms.value[index]
            rooms.value.push({...item})
          }
          const deleteRoom = (index) => {
            if(index > 0){
                rooms.value.splice(index, 1)
            }
          }
          const updateModal = (value) => {
                  emit("update:modal", value); // Sync modal state with parent
              };
          return{
              updateModal,
              type_rooms,
              rooms,
              selectHousekeeping,
              selectNoRoom,
              addRoom,
              deleteRoom,
              housekeepers
          }
      }
  }
  </script>
  
  <style>
  
  </style>